{
  "de": {
    "todo_list": {
      "actions": {
        "add": "Aufgabenliste erstellen",
        "cancel": "Rückgängig machen",
        "delete_todo_list": "Liste löschen",
        "edit": "Aufgabenliste bearbeiten",
        "new": "Aufgabenliste",
        "save": "Speichern",
        "title": "Listentitel"
      },
      "attributes": {
        "name": "Titel"
      },
      "labels": {
        "assignToLevel": "Einer Ebene zuweisen",
        "createdAt": "Erstellt am",
        "filter_employee": "Verantwortlich",
        "newTodoList": "Neue Aufgabenliste",
        "sort": {
          "created_at_asc": "Älteste zuerst",
          "created_at_desc": "Neueste zuerst",
          "name_lower_asc": "Titel A -> Z",
          "name_lower_desc": "Titel Z -> A"
        }
      },
      "phase_out": {
        "body": "Aufgaben (alt) endet Ende 2026. Übertrage Aufgaben, die du noch brauchst, vor dem 1. Januar 2027 nach Aufgaben. Bis dahin kannst du bestehende Aufgaben weiter nutzen und abschließen.",
        "title": "Aufgaben (alt) wird eingestellt"
      },
      "placeholders": {
        "empty": "Keine Aufgabenlisten hier"
      },
      "toasts": {
        "create": "Aufgabenliste erfolgreich erstellt",
        "delete": "Aufgabenliste wurde erfolgreich gelöscht",
        "update": "Aufgabenliste wurde erfolgreich aktualisiert"
      },
      "validation": {
        "needTitle": "Titel erforderlich"
      }
    }
  }
}
